module.exports = ".nav-pills .nav-link.active,\r\n.nav-pills .show > .nav-link {\r\n  color: #fff;\r\n  background-color: #5c80d1;\r\n}\r\n\r\na {\r\n  cursor: pointer;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/myprofile-left-nav/myprofile-left-nav.component.css
// module id = ./src/app/shared/components/myprofile-left-nav/myprofile-left-nav.component.css
// module chunks = main